// WhatsAppInput.tsx
import React, { useState, useEffect, forwardRef } from 'react'
import { Input, InputProps } from '@/components/ui/input'

export const formatWhatsApp = (value: string = '') => {
  let digits = value.replace(/\D/g, '')
  if (digits.length > 11) digits = digits.slice(0, 11)

  return digits
    .replace(/^(\d{2})(\d)/, '($1) $2')
    .replace(digits.length === 11 ? /(\d{5})(\d)/ : /(\d{4})(\d)/, '$1-$2')
}

type WhatsAppInputProps = Omit<InputProps, 'value' | 'onChange'> & {
  value?: string
  onChange?: (value: string) => void // <- agora é onChange
  onBlur?: () => void // <- RHF também usa
}

const WhatsAppInput = forwardRef<HTMLInputElement, WhatsAppInputProps>(
  ({ value = '', onChange, onBlur, ...rest }, ref) => {
    const [raw, setRaw] = useState(value)

    useEffect(() => setRaw(value), [value])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const digits = e.target.value.replace(/\D/g, '')
      setRaw(digits)
      onChange?.(digits) // RHF recebe só dígitos
    }

    return (
      <Input
        {...rest}
        ref={ref}
        name={rest.name} // garante que o nome chegue ao input real
        value={formatWhatsApp(raw)}
        onChange={handleChange}
        onBlur={onBlur}
        inputMode="numeric"
        placeholder="(00) 00000‑0000"
        maxLength={15}
        className="bg-input text-foreground font-sans text-sm p-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    )
  }
)

export default WhatsAppInput
